module.exports = __webpack_public_path__ + "img/mp.b16cabc5.svg";